"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppDynamicsLoader = void 0;
const scriptLibraryLoader_1 = require("../../../core/library/loader/scriptLibraryLoader");
const constants_1 = require("./constants");
class AppDynamicsLoader extends scriptLibraryLoader_1.ScriptLibraryLoader {
    constructor(appDynamicsAppKey) {
        super('AppDynamics', constants_1.LOAD_CONFIG);
        this.jsonAppDynamics = {};
        this.baseConfig = constants_1.CONFIG;
        this.appDynamicsAppKey = appDynamicsAppKey;
    }
    getJsonAppDynamics() {
        return {
            userData: this.jsonAppDynamics,
        };
    }
    setConfig() {
        if (!window[constants_1.ADRUM_CONFIG]) {
            window[constants_1.ADRUM_CONFIG] = {};
        }
        window[constants_1.ADRUM_CONFIG] = Object.assign(Object.assign(Object.assign({}, window[constants_1.ADRUM_CONFIG]), this.baseConfig), { appKey: this.appDynamicsAppKey });
    }
    setInfo() {
        if (!window[constants_1.ADRUM_CONFIG].userEventInfo) {
            window[constants_1.ADRUM_CONFIG].userEventInfo = {};
        }
        window[constants_1.ADRUM_CONFIG].userEventInfo = Object.assign(Object.assign({}, window[constants_1.ADRUM_CONFIG].userEventInfo), { Ajax: this.getJsonAppDynamics, PageView: this.getJsonAppDynamics, VPageView: this.getJsonAppDynamics });
    }
    setStartDate() {
        window[constants_1.ADRUM_START_TIME] = new Date().getTime();
    }
    preload() {
        this.setStartDate();
        this.setConfig();
        this.setInfo();
    }
    getUrls() {
        return [constants_1.URL];
    }
}
exports.AppDynamicsLoader = AppDynamicsLoader;
//# sourceMappingURL=index.js.map